// import { store } from "store";
// import { logout as logoutAction } from "store/actions";

export const getAdminToken = () => {
  return localStorage.getItem("token");
};


export const logout = () => {
  localStorage.clear();
};

export const isTokenExpired = (error) => {
  const { response } = error;
  if (response) {
    if (response.status === 401) {
      logout();
    }
    return Promise.reject(error);
  }
};
